export default {"src":"/_next/static/media/cauliflower.32343733.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};